import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { BookPrintResponse } from '../../responses/platform/book-print.response';
import { BookPrintSelectedRequest } from '../../requests/platform/book-print-selected.request';
import { BookPrintSelectedResponse } from '../../responses/platform/book-print-selected.response';

@Injectable({
  providedIn: 'root'
})
export class BookPrintService extends CommonService {
  constructor(private http: HttpClient) {
    super();
  }

  public getActive(idBookVersion: number): Observable<BookPrintResponse> {
    return this.http
      .get<BookPrintResponse>(environment.urlApiPlatform + "BookPrint/getAvaliable/idBookVersion/" + idBookVersion, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public getActiveByNumPages(numPages: number): Observable<BookPrintResponse> {
    return this.http
      .get<BookPrintResponse>(environment.urlApiPlatform + "BookPrint/getAvaliable/pages/" + numPages, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

    public selectBookPrint(request: BookPrintSelectedRequest): Observable<BookPrintSelectedResponse> {
        return this.http
            .post<BookPrintSelectedResponse>(environment.urlApiPlatform + "BookPrint/select/", request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
